/**
 * Created by 高春超 on 2018/1/23.
 * 公共方法类
 */


/**
 * 格式化时间
 */
const getPadd = (num, n) => {
  let len = num.toString().length;
  while (len < n) {
    num = "0" + num;
    len++;
  }
  return num;
}
/**
 * 获取当前时间
 */
export function getNowFormatDate() {
  let date = new Date();
  return date.getFullYear() +
    getPadd(date.getMonth() + 1, 2) +
    getPadd(date.getDate(), 2) +
    getPadd(date.getHours(), 2) +
    getPadd(date.getMinutes(), 2) +
    getPadd(date.getUTCSeconds(), 2) +
    getPadd(date.getUTCMilliseconds(), 3);
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  if (time === null || time.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time == 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}


export function getSession(key) {
  return localStorage.getItem(key) == null ? '' : localStorage.getItem(key)
}
export function setSession(key, val) {
  return localStorage.setItem(key, val)
}
export function removeSession(key) {
  return localStorage.removeItem(key)
}

export function clearSession() {
  // console.log('clear sid');
  return localStorage.clear();
}

export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf('?') + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/*
因为后台返回的跳转url按照以前商城的格式，不适用于单页，所以做个统一处理
这里要分 有goods-id 跳转到商品详情
关键字goods_list => 商品列表
关键字 store_id 店铺详情
*/
export function parseAdvList(data = [], key = 'url') {
  let list = data;
  let _list = list.map((item, index) => {
    let url = !!item[key] ? item[key] : '';
    let to = { path: '', query: {} };

    if (url.match(/goods-/i)) { //匹配老系统的商品详情
      let begin = url.indexOf("goods-") + 6;
      let end = url.indexOf(".html");
      let goodsId = url.slice(begin, end);
      let query1 = { goods_id: goodsId };
      let query2 = getQueryObject(url) || {};
      to = { path: '/goods', query: { ...query1, ...query2 } };
    } else if (url.match(/goods\?goods_id=/i)) { //匹配新系统的商品详情
      let query = getQueryObject(url) || {};
      to = { path: '/goods', query: query };
    } else if (url.match(/goods_list.html/i)) { //匹配老系统的商品商品列表
      let query = getQueryObject(url) || {};
      query.tab = 1;
      if (query.namekeyword) {
        let keyword = query.namekeyword;
        delete query.namekeyword;
        query.keyword = keyword;
      }
      to = { path: '/goods-list', query: query };
    } else if (url.match(/store_id=/i)) { //匹配新，老系统的商品商品列表
      let query = getQueryObject(url) || {};
      if (!query.tab) query.tab = 1;
      if (key === 'nav_url') { // 从自营商城菜单跳转到店铺详情（要求进入搜索tab） （修改 魏强 2018.5.25）
        if (!query.tab) query.tab = 2;
        item.name && (query.name = item.name);
        item.nav_url && (query.nav_url = item.nav_url);
      }
      to = { path: '/shop', query: query };
    } else if (url.match(/banner/i)) {
      // 匹配新定义banner解析规则
      // http://103.235.254.233:8081/banner?type=1
      // http://103.235.254.233:8081/banner?type=2
      // type=1 表示跳转指定商品列表
      // 后面有新增的规则就type=2 依次分类
      let query = getQueryObject(url) || {};
      // 跳转指定商品列表
      if (query.type === '1') {
        to = { path: '/recommend-goods', query: query };
      } else {
        var index = url.lastIndexOf("\/");
        to = { path: url.substring(index + 1, url.length) };
      }
    } else {
      var index = url.lastIndexOf("\/");
      to = { path: url.substring(index + 1, url.length) };
    }
    item.to = to;
    item.key = index;
    return item;
  });
  return _list;
}

export function formatDate(strTime) {
  var date = new Date(strTime * 1000);
  return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
}

/*搜索输入延迟回调*/
export function debounce(func, delay) {
  let timer
  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

/*保留两位小数，不四舍五入*/
export const cutOutNum = (num) => {
  if (isNaN(num) || (!num && num !== 0)) {
    return '--'
  }
  // 默认为保留的小数点后两位
  // let dec = decimals ? decimals : 2
  let dec = 2;
  let tempNum = Number(num)
  let pointIndex = String(tempNum).indexOf('.') + 1 // 获取小数点的位置 + 1
  let pointCount = pointIndex ? String(tempNum).length - pointIndex : 0 // 获取小数点后的个数(需要保证有小数位)
  // 源数据为整数或者小数点后面小于decimals位的作补零处理
  if (pointIndex === 0 || pointCount <= dec) {
    let tempNumA = tempNum
    if (pointIndex === 0) {
      tempNumA = `${tempNumA}.`
      for (let index = 0; index < dec - pointCount; index++) {
        tempNumA = `${tempNumA}0`
      }
    } else {
      for (let index = 0; index < dec - pointCount; index++) {
        tempNumA = `${tempNumA}0`
      }
    }
    return tempNumA
  }
  let realVal = ''
  // 截取当前数据到小数点后decimals位
  realVal = `${String(tempNum).split('.')[0]}.${String(tempNum)
    .split('.')[1]
    .substring(0, dec)}`
  // 判断截取之后数据的数值是否为0
  if (realVal == 0) {
    realVal = 0
  }
  return realVal
}

/*生成随机字符串*/
export const randomString = (len) => {
  len = len || 32;
  let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  let maxPos = $chars.length;
  let string = '';
  for (let i = 0; i < len; i++) {
    string += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return string;
}

export const isIdCard = idCard => {
  /* eslint-disable */
  // 15位和18位身份证号码的正则表达式
  var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;

  // 如果通过该验证，说明身份证格式正确，但准确性还需计算
  if (regIdCard.test(idCard)) {
    if (idCard.length == 18) {
      var idCardWi = new Array(
        7,
        9,
        10,
        5,
        8,
        4,
        2,
        1,
        6,
        3,
        7,
        9,
        10,
        5,
        8,
        4,
        2
      ); // 将前17位加权因子保存在数组里
      var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
      var idCardWiSum = 0; // 用来保存前17位各自乖以加权因子后的总和
      for (var i = 0; i < 17; i++) {
        idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
      }

      var idCardMod = idCardWiSum % 11; // 计算出校验码所在数组的位置
      var idCardLast = idCard.substring(17); // 得到最后一位身份证号码

      // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
      if (idCardMod == 2) {
        if (idCardLast == 'X' || idCardLast == 'x') {
          //alert("恭喜通过验证啦！");
          return true;
        } else {
          //alert("身份证号码错误！");
          return false;
        }
      } else {
        // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
        if (idCardLast == idCardY[idCardMod]) {
          //alert("恭喜通过验证啦！");
          return true;
        } else {
          //alert("身份证号码错误！");
          return false;
        }
      }
    } else {
      return true;
    }
  } else {
    //alert("身份证格式不正确!");
    return false;
  }
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/utils/tool.js